<template>
  <div>
    <div class="latest-news">
      <div style="margin-top: 5px;float: left;">
        <latest-news></latest-news>
      </div>
      <div class="message-box">
        <div class="ui-box">
        <ul>
          <li style="list-style: none">&nbsp;
            <span>
              <a href="javascript:void(0)" @click="getIntoList" class="more">More &rsaquo;&rsaquo;&rsaquo;</a>
            </span>
            <div class="transverse-line"></div>
          </li>
          <li v-for="(nav, index) in latestNews" :key="index">
            <a href="javascript:void(0)" style="color: #000000;font-size: 14px;" @click="getIntoNews(nav)">{{nav.title}}</a>
            <div class="newsPopupBox" >
              <NewsPopup v-show="flag" :show="flag" :newsObj="newsObj" :is_show_course ="is_show_course" :newCourse = "newCourse" @close="()=>flag = false"></NewsPopup>
            </div>
            <span>{{nav.time}}</span>
            <div class="transverse-line"></div>
          </li>
        </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LatestNews from "../../../common/components/LatestNews";
  import NewsPopup from "../../newsPopup/newsPopup";
  import Vue from 'vue';
  import { mapState } from 'vuex'
  export default {
    name: "hotNews",
    data(){
      return {
        flag: false,
        is_show_course:false,
        newsObj:'',
        newCourse:[],
      }
    },
    components: {NewsPopup, LatestNews},
    // props:{
    //   LatestNews:{
    //   },
    // },
    computed: {
      ...mapState({
        latestNews: (state) => state.latestNews,
      }),
    },
    methods: {
      async getIntoNews(nav){
        let  user = localStorage.getItem("userInfo");
        if(!user){
          this.$Message.warning({content: this.$t('i.login.LoginMsg'),duration: 5});
          return false;
        }
        const json = await this.RequestUtil.request("/front/news/showNewsCourse?id=" + nav.id);
        if(json){
          if(json.statusCode == this.Constants.statusCode.ok){
            if(json.datas.list.length == 0){
               this.is_show_course = false;
            }else{
               this.is_show_course = true;
               this.newCourse = json.datas.list;
            }
            this.flag=true;
            this.newsObj= nav;
          }
        }
      },
      async getIntoList(){
        let  user = localStorage.getItem("userInfo");
        if(!user){
          this.$Message.warning({content: this.$t('i.login.LoginMsg'),duration: 5});
          await this.$router.push({name:'login'})
          return false;
        }
        this.$router.push({name:'news'})
      }
    }
  }
</script>

<style scoped>
  .latest-news{
    width: 862px;
    height: 315px;
    float: left;
    overflow: hidden;
  }
  .message-box{
    width: 750px;
    height: 280px;
    margin-left: 130px;
    overflow: hidden;
    position: relative;
  }
  .ui-box{
    width: 750px;
    height: 250px;
    position: absolute;
    top: -32px;
    left: 0px;
  }

  .message-box ul li{
    width: 600px;
    height: 25px;
    margin-left: 37px;
    margin-top: 18px;
    text-decoration: -moz-none;
    text-decoration: none;
  }

  .transverse-line{
    width: 675px;
    height: 1px;
    background-color: #d3d7d8;
    margin-top: 12px;
    margin-left: -35px;
  }

  .message-box span{
    left: 570px;
    position: absolute;
    color: #949494;
    font-size: 12px;
  }
  .more{
    width: 60px;
    position: absolute;
    color: #393939;
    top: 8px;
    font-size: 14px;
  }
  .newsPopupBox{
    position: absolute;
    z-index: 110;
  }

</style>



// WEBPACK FOOTER //
// src/pages/home/components/hotNews.vue